import { Component, OnInit } from '@angular/core';
import { AppMetadataHandler } from 'app';

@Component({
  selector: 'app-capture-proposal',
  templateUrl: './capture-proposal.component.html',
  styleUrls: ['./capture-proposal.component.scss']
})
export class CaptureProposalComponent implements OnInit {

  constructor(
    public appMetadataHandler: AppMetadataHandler
  ) { }

  date = null; // new Date();
    dateRange = []; // [ new Date(), addDays(new Date(), 3) ];
    isEnglish = false;

    onChange(result: Date): void {
        console.log('onChange: ', result);
    }

  ngOnInit() {
  }

  //TODO Added for AOT
  cardCollapsed
  insuredCardCollapsed
  coverageCardCollapsed
  agentCardCollapsed
  allChecked
  indeterminate
  radioValue
  currentPageDataChange(event){}
  refreshStatus(){}
  checkAll(event){}

  data = [
    'Hospital Cash',
    'Private Room',
    'Out-Patient Consultation',
    'Dental Cover',
    'Critical Illness'
  ];
  insureddata1 = null
  insureddata = [
    {
      title: 'Owner',
      name: "Ninad Kulkarni"
    },
    {
      title: 'Payer',
      name: "Ninad Kulkarni"
    },
    {
      title: 'Primary Insured',
      name: "Ninad Kulkarni"
    },
    {
      title: 'Insured',
      name: "Amit Naik"
    },
  ];

  agentdata = [
    {
      title: 'Primary Agent',
      name: "John Smith"
    },
    {
      title: 'Agent',
      name: "Chuk Norris"
    }
  ];


  /* Search Modal */
  isVisibleMiddle :boolean = false;
  showModalMiddle(): void {
      this.isVisibleMiddle = true;
  }
  handleOkMiddle(): void {
      console.log('Modal: click ok');
      this.isVisibleMiddle = false;
  }
  handleCancelMiddle(): void {
      this.isVisibleMiddle = false;
  }

  /* Client Capture Modal */
  isClientCaptureModalVisible :boolean = false;
  showClientCaptureModalMiddle(): void {
      this.isClientCaptureModalVisible = true;
  }
  handleClientCaptureOkMiddle(): void {
      console.log('Modal: click ok');
      this.isClientCaptureModalVisible = false;
  }
  handleClientCaptureCancelMiddle(): void {
      this.isClientCaptureModalVisible = false;
  }

   /* Table */
   displayData = [];
   dataTable = [
       {
           name    : 'John Brown',
           age     : 32,
           address : 'New York No. 1 Lake Park',
           checked : false,
           disabled: false
       },
       {
           name    : 'Jim Green',
           age     : 42,
           address : 'London No. 1 Lake Park',
           checked : false,
           disabled: false
       },
       {
           name    : 'Joe Black',
           age     : 32,
           address : 'Sidney No. 1 Lake Park',
           checked : false,
           disabled: false
       },
       {
           name    : 'Disabled User',
           age     : 32,
           address : 'Sidney No. 1 Lake Park',
           checked : false,
           disabled: true
       }
   ];

   isLoadingOne = false;
   loadOne(): void {
    this.isLoadingOne = true;
    setTimeout(_ => {
      this.isLoadingOne = false;
    }, 5000);
  }

}
